import { render, staticRenderFns } from "./detailType2.vue?vue&type=template&id=77acb96a&scoped=true"
import script from "./detailType2.vue?vue&type=script&lang=js"
export * from "./detailType2.vue?vue&type=script&lang=js"
import style0 from "./detailType2.vue?vue&type=style&index=0&id=77acb96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77acb96a",
  null
  
)

export default component.exports